export default __webpack_public_path__ + "static/media/arbitrum_logo.3c4f3a9c.svg";